import React from 'react';

function Settings() {
  return (
    <div className="settings">
      <h2>Settings</h2>
      <p>Adjust your preferences here.</p>
    </div>
  );
}

export default Settings;